import { render, staticRenderFns } from "./IndustriesDetails.vue?vue&type=template&id=7dd33126&scoped=true"
import script from "./IndustriesDetails.vue?vue&type=script&lang=ts"
export * from "./IndustriesDetails.vue?vue&type=script&lang=ts"
import style0 from "./IndustriesDetails.vue?vue&type=style&index=0&id=7dd33126&lang=scss"
import style1 from "./IndustriesDetails.vue?vue&type=style&index=1&id=7dd33126&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd33126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd33126')) {
      api.createRecord('7dd33126', component.options)
    } else {
      api.reload('7dd33126', component.options)
    }
    module.hot.accept("./IndustriesDetails.vue?vue&type=template&id=7dd33126&scoped=true", function () {
      api.rerender('7dd33126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/industries/components/IndustriesDetails.vue"
export default component.exports